var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ride-option",class:{ selected: _vm.selected }},[_c('div',{staticClass:"text-body-4"},[_vm._v(_vm._s(_vm.rideOption.title))]),(_vm.rideOption.description)?_c('div',{staticClass:"text-body-5"},[_vm._v(" "+_vm._s(_vm.rideOption.description)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }